import { MESSAGE_ACTION_TYPES } from '../actions/types';

const initialState = {
  count: 0,
  loading: false,
  error: null,
};

const messageReducer = (state = initialState, action) => {
  switch (action.type) {
    case MESSAGE_ACTION_TYPES.FETCH_MESSAGE_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case MESSAGE_ACTION_TYPES.FETCH_MESSAGE_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        count: action.payload.count || 0,
        error: null,
      };
    case MESSAGE_ACTION_TYPES.FETCH_MESSAGE_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case MESSAGE_ACTION_TYPES.RESET_MESSAGE_COUNT:
      return {
        ...state,
        count: 0,
      };
    default:
      return state;
  }
};

export default messageReducer;

